<template>
    <div class="relative">
        <router-link
            class="gap-2 flex items-center justify-center underline hover:text-slate-600 focus:text-slate-500 focus:outline-slate-300 ml-2 rounded"
            v-if="activeProperty?.user_alerts?.length > 0"
            to="/alerts"
        >
            <Icon icon="alert" svgClass="w-5 h-5" />
            <div>
                <span>{{ activeProperty.user_alerts.length }}</span>
                <span>
                    Alert{{ activeProperty.user_alerts.length > 1 ? 's' : '' }}
                </span>
            </div>
        </router-link>
    </div>
</template>

<script>
import { computed } from 'vue';
import { useAlertsStore } from '@/store/alerts';
import Icon from '@/components/ui/icon/icon.vue';

export default {
    components: { Icon },
    setup() {
        const alertsStore = useAlertsStore();

        const activeProperty = computed(() => alertsStore.activeProperty);
        return { activeProperty };
    },
};
</script>
